import { IErrorInfo } from '../contracts/error-info';
import { IAction } from './action';

export class SetError implements IAction {
    constructor(public error: Partial<IErrorInfo>) { }
}
